import React from 'react';
export function StaffingCostsHeading() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Salary"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Bonus"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "ER NI"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Pension"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Reimbursed"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Total Costs"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "Capitalised Amount"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "R&D Amount"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "P&L Expenditure"), /*#__PURE__*/React.createElement("th", {
    className: "financial_headings"
  }, "S1308"));
}